export var compKey = 'range-label';
//# sourceMappingURL=key.js.map